const rad = x => {
  return (x * Math.PI) / 180
}

export const getDistance = (p1, p2) => {
  const earthRadius = 6378137 // Earth’s mean radius in meter
  const lat = rad(p2.lat - p1.lat)
  const lng = rad(p2.lon - p1.lon)
  const a =
    Math.sin(lat / 2) * Math.sin(lat / 2) +
    Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(lng / 2) * Math.sin(lng / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const kilometers = (earthRadius * c) / 1000
  const factor = 0.621371
  return kilometers * factor
}
